import { render, staticRenderFns } from "./AsideMenuListPlain.vue?vue&type=template&id=002b9330"
import script from "./AsideMenuListPlain.vue?vue&type=script&lang=js"
export * from "./AsideMenuListPlain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports